import { render, staticRenderFns } from "./IObjectMultiPicker.vue?vue&type=template&id=2ed2ab27&"
import script from "./IObjectMultiPicker.vue?vue&type=script&lang=js&"
export * from "./IObjectMultiPicker.vue?vue&type=script&lang=js&"
import style0 from "./IObjectMultiPicker.vue?vue&type=style&index=0&id=2ed2ab27&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports